import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'

export const Anchor: MantineThemeComponents['Anchor'] = {
    styles: (__, anchorProps): Record<string, CSSObject> => {
        return {
            root: {
                textDecoration: anchorProps.underline ? 'underline' : 'none',
                color: 'var(--mantine-text-link)'
            }
        }
    }
}
